import React from 'react'
import PropTypes from 'prop-types'
import { Card, Grid2 } from '@mui/material'
import Input from '../../../../components/forms/Input'
import i18n from '../../../../simple-react-i18n'
import { getSetting } from '../../../../utils/SettingUtils'
import Select from '../../../../components/forms/Select'
import { i18nize } from '../../../../utils/StringUtil'
import { FR, SUPPORTED_LANGUAGES } from '../../../../referencial/constants/ReferencialConstants'
import SieauParameterDto from '../../../dto/SieauParameterDto'

const SupportPanel = ({
    applicationSettings= [],
    onChangeSettings = () => {},
    disabled = false,
}) => (
    <Card sx={{ padding: '0.5rem', borderRadius: '0 0 5px 5px' }}>
        <Grid2 container spacing={1}>
            <Grid2 size={4}>
                <Input
                    title={ i18n.supportMailAddress }
                    value={ getSetting(applicationSettings, 'supportMailAddress') }
                    onChange={ (v) => onChangeSettings('supportMailAddress', v) }
                    { ...disabled }
                />
            </Grid2>
            <Grid2 size={4}>
                <Input
                    title={ i18n.supportPhoneNumber }
                    value={ getSetting(applicationSettings, 'supportPhoneNumber') }
                    onChange={ (v) => onChangeSettings('supportPhoneNumber', v) }
                    { ...disabled }
                />
            </Grid2>
            <Grid2 size={4}>
                <Input
                    title={ i18n.supportContactSchedule }
                    value={ getSetting(applicationSettings, 'supportContactSchedule') }
                    onChange={ (v) => onChangeSettings('supportContactSchedule', v) } { ...disabled }
                />
            </Grid2>
            <Grid2 size={4}>
                <Input
                    title={ i18n.companyAddress }
                    value={ getSetting(applicationSettings, 'companyAddress') }
                    onChange={ (v) => onChangeSettings('companyAddress', v) } { ...disabled }
                />
            </Grid2>
            <Grid2 size={4}>
                <Input
                    title={ i18n.siretNumber }
                    value={ getSetting(applicationSettings, 'siretNumber') }
                    onChange={ (v) => onChangeSettings('siretNumber', v) }
                    { ...disabled }
                />
            </Grid2>
            <Grid2 size={4}>
                <Input
                    title={ i18n.companyPhoneNumber }
                    value={ getSetting(applicationSettings, 'companyPhoneNumber') }
                    onChange={ (v) => onChangeSettings('companyPhoneNumber', v) }
                    { ...disabled }
                />
            </Grid2>
            <Grid2 size={4}>
                <Input
                    title={ i18n.urlHelpCenter }
                    value={ getSetting(applicationSettings, 'urlHelpCenter') }
                    onChange={ (v) => onChangeSettings('urlHelpCenter', v) } { ...disabled }
                />
            </Grid2>
            <Grid2 size={4}>
                <Input
                    title={ i18n.urlFormationPlatform }
                    value={ getSetting(applicationSettings, 'urlFormationPlatform') }
                    onChange={ (v) => onChangeSettings('urlFormationPlatform', v) } { ...disabled }
                />
            </Grid2>
            <Grid2 size={4}>
                <Input
                    title={ i18n.formationToken }
                    value={ getSetting(applicationSettings, 'formationToken') }
                    onChange={ (v) => onChangeSettings('formationToken', v) } { ...disabled }
                />
            </Grid2>
            <Grid2 size={4}>
                <Input
                    title={ i18n.locationHelp }
                    value={ getSetting(applicationSettings, 'FichierAide') }
                    onChange={ v => onChangeSettings('FichierAide', v) } { ...disabled }
                />
            </Grid2>
            <Grid2 size={4}>
                <Select
                    label={i18n.supportLanguage}
                    options={i18nize(SUPPORTED_LANGUAGES)}
                    noNullValue
                    keyLabel='label'
                    value={getSetting(applicationSettings, 'supportLanguage') || FR}
                    onChange={v => onChangeSettings('supportLanguage', v)}
                    {...disabled}
                />
            </Grid2>
        </Grid2>
    </Card>
)

SupportPanel.propTypes = {
    applicationSettings: PropTypes.arrayOf(PropTypes.instanceOf(SieauParameterDto)),
    onChangeSettings: PropTypes.func,
    disabled: PropTypes.shape({
        active: PropTypes.bool,
        disabled: PropTypes.bool,
    }),
}

export default SupportPanel